// libs
import React, { memo } from "react";
import { useLocation, useHistory } from "react-router";

// component
import OtpFlow from "shared/layouts/OTPVerification/Mobile";
import AuthModal from "shared/components/AuthModal";

// Helpers
import { actionsForMagento } from "./helpers";

const containDomainName = (text: string) => /(https:\/\/|http:\/\/|www\.)\S+/i.test(text);

interface IMobileAuthFlowProps {
    isEnabledForMobile: boolean;
    isEnabledForDesktop: boolean;
    isUserLoggedIn: boolean;
    isIndianUser: boolean;
}

function MobileAuthFlow({
    isEnabledForMobile,
    isEnabledForDesktop,
    isUserLoggedIn,
    isIndianUser,
}: IMobileAuthFlowProps) {
    const { search } = useLocation();
    const history = useHistory();

    const URLParams = new URLSearchParams(search);
    const redirectionURL = (URLParams.get("redirectURL") || "").replace("@", "?");
    const router = URLParams.get("route");
    const isLegacyCheckoutFlow = router === "checkout";
    const isLegacyDiscoveryFlow = router === "discovery";
    const comingViaLegacyCode = isLegacyCheckoutFlow || isLegacyDiscoveryFlow;

    const shouldShowNewFlow =
        isIndianUser &&
        ((comingViaLegacyCode && isEnabledForDesktop) ||
            (!comingViaLegacyCode && isEnabledForMobile));

    const onModalClose = (closeOnly = false) => {
        if (comingViaLegacyCode) {
            actionsForMagento(closeOnly);
            return;
        }

        if (redirectionURL.includes(window.location.host)) {
            window.location.href = redirectionURL;
            return;
        }

        if (containDomainName(redirectionURL)) {
            history.replace("/");
            return;
        }

        history.replace(redirectionURL);
    };

    if (shouldShowNewFlow) {
        return (
            <OtpFlow
                hide={onModalClose}
                isUserLoggedIn={isUserLoggedIn}
                isCheckoutFlow={isLegacyCheckoutFlow}
            />
        );
    }

    return <AuthModal onHide={onModalClose} redirectUrl={redirectionURL} />;
}

export default memo(MobileAuthFlow);
